const customValid = require('./customValidation.js');
const _ = require('lodash');
import ko from 'rgs-knockout';
const Serializable = require('serializable');

function compensationBaseInfo (predictionName) {
	const src = Serializable({
		FirstName: ko.observable().extend({
			validation: customValid.cyrrilicOnly,
			required: true,
		}),
		MiddleName: ko.observable(),
		LastName: ko.observable().extend({
			validation: customValid.cyrrilicOnly,
			required: true,
		}),
	}, {
		toJS: function (_super) {
			let js = _super();
			js = _.mapKeys(js, function (val, key){
				return predictionName + key;
			});

			return js;
		},
	});

	return src;
}

function compensationDeclarantPersonInfo () {
	const src = Serializable({
		FirstName: ko.observable().extend({
			validation: customValid.cyrrilicOnly,
			required: true,
		}),
		MiddleName: ko.observable(),
		LastName: ko.observable().extend({
			validation: customValid.cyrrilicOnly,
			required: true,
		}),
		Province: ko.observable().extend({required: true }),
		City: ko.observable().extend({required: true }),
		Street: ko.observable().extend({required: true }),
		House: ko.observable().extend({required: true }),
		Block: ko.observable(),
		Apartment: ko.observable().extend({required: true }),
	}, {
		toJS: function (_super) {
			let js = _super();
			js = _.mapKeys(js, function (val, key){
				return 'DeclarantPerson' + key;
			});

			return js;
		},
	});

	return src;
}

function compensationAdditionalInfo () {
	const src = Serializable({
		DocumentSendDate: ko.observable().extend({ pattern: /\d{2}\.\d{2}\.\d{4}/ }),
		RegistrationMailNumber: ko.observable(),
	});

	return src;
}

module.exports = function () {
	const src = {
		PolicyHolder: compensationBaseInfo('PolicyHolder'),
		InsuredPerson: compensationBaseInfo('InsuredPerson'),
		DeclarantPerson: compensationDeclarantPersonInfo(),
		AdditionalInfo: compensationAdditionalInfo(),
	};

	src.toJS = function () {
		return _.transform(src, function (result, prop, propName){
			if (propName !== 'toJS') {
				_.extend(result, prop.toJS());
			}
		}, {});
	};

	return src;
};
